export const suppressCanceled = (e: Error) => {
  if (e.message !== 'canceled') {
    throw e
  }
}
